import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';



@Component({
  selector: 'app-worker-app',
  templateUrl: './worker-app.component.html',
  styleUrls: ['./worker-app.component.scss']
})
export class WorkerAppComponent implements OnInit {

  @Input() worker:any;

  constructor() { }

  ngOnInit(): void {
    
  }

}
